define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/comm/PostRequest",
	"csi/table/AggregateFrom",
	"csi/xml",
	"csi/xml/Query",
	"csi/_base/underscore"
], function(declare,lang,PostRequest,AggregateController,xml,Query,_) {

	return declare(AggregateController, {
		applyActionFilters: function(/*csi.view.Widget*/view) {

			/* additional filter for the AttachMaterialSample action under ProductSource node:
			it should only present samples from the same supplier, e.g.
			samples owned by ProductSource nodes with the same Supplier as this ProductSource node */
			var ctx = this.getContext();
			var urlRoot = ctx.view.urlRoot;
			var rootNode =  ctx.cache.getNode(urlRoot, true);

			if(rootNode.$Type == "ProductSource") {
				var query = new Query().RefAttr("Supplier", xml.OP_EQUALS, rootNode.Supplier, "Child:__Parent__");
				if (query) {
					view.relRoot.addQuery(query);
				}
			}
			this.inherited(arguments);
		},

		getFormData: function() {
			var	data = this.inherited(arguments);
			data.m_bSelectOne = false;
			data.m_bRequireOne = false;
			return data;
		},

		process: function() {
			// summary: issue request so as to be able to receive return value
			var	req = this.m_action.m_request;
			var fd = this.m_formData;

			this.setProgress();

			var parentNode = this.getParent();

			var materialUrl;
			var colorMaterial;
			switch(parentNode.$Type) {
			    case "ColorMaterial":
			    	materialUrl = parentNode.__Parent__;
			    colorMaterial = parentNode;
			        break;
			    case "ProductSource":
			    	var materialSourcingNode = this.getCache().getNode(parentNode.__Parent__);
			    	materialUrl = materialSourcingNode.__Parent__;
			        break;
			    default:
			    	materialUrl = parentNode.$URL;
			}

			var multiMaterial_Selection = new PostRequest(req.m_module, req.m_operation);
			multiMaterial_Selection.addParameter(xml.PROP_URL_PARENT, materialUrl);
			if(colorMaterial){
			    multiMaterial_Selection.addParameter("SpecificColorMaterial", colorMaterial.$URL);
			}
			_.each(fd.getSelectedNodes(), function(val){
				multiMaterial_Selection.addParameter(xml.PROP_URL, val.$URL, true);
			})
			multiMaterial_Selection.post({}).then(lang.hitch(this, this._onPublishResponse));

		},

		postProcessSuccess: function() {
			this.widget.refreshWidget();
		}
	});
});